<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <p @click="$router.go(-1)" class="back">back</p>
      <md-card>
        <md-card-content>
          <md-field>
            <label>Title</label>
            <md-input v-model="client.name" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Email</label>
            <md-input v-model="client.email" type="email"></md-input>
          </md-field>
          <md-field>
            <label>Phone</label>
            <md-input v-model="client.phone" type="number"></md-input>
          </md-field>
          <md-field>
            <label>Screen Saver Videos</label>
            <md-select v-model="client.videos" multiple>
              <md-option
                v-for="video in videos"
                :key="video.id"
                :value="video.media"
                >{{ video.name }}</md-option
              >
            </md-select>
          </md-field>
          <md-field>
            <label>Description</label>
            <md-textarea
              v-model="client.description"
              md-autogrow
              md-counter="200"
            ></md-textarea>
          </md-field>
          <Upload :media_type="'image'" :media="media"></Upload>
          <!-- <md-field>
            <label>Client Logo</label>
            <md-input class="upload" ref="upload" type="file" accept="image/*" @change="uploadImage" v-model="client.client_logo"></md-input>
          </md-field> -->
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <md-button class="md-primary md-round md-small" @click="validate"
            >Save</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import Fuse from "fuse.js";
import { db, storage } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import router from "@/router";
import Upload from "../../components/Inputs/Upload.vue";

export default {
  components: {
    Upload
  },
  data() {
    return {
      media: null,
      client: {
        name: "",
        email: "",
        phone: "",
        description: "",
        videos: [],
        client_logo: null
      },
      logoLoad: false,
      location: null,
      type_options: [
        { val: "video", text: "Video" },
        { val: "image", text: "Image" },
        { val: "survey", text: "Survey" },
        { val: "iframe", text: "iFrame" }
      ],
      files: [],
      upload_progress: null,
      upload_error: null,
      videos: [],
      surveys: [],
      locations: [],
      videos: []
    };
  },
  watch: {
    client: {
      handler(val) {
        if (!this.client.created) {
          this.client.slug = val.name.replace(/[^a-zA-Z0-9]/g, "-");
        }
        this.media = this.client.client_logo;
      },
      deep: true
    },
    media() {
      this.client.client_logo = this.media;
    },
    location(val) {
      this.client.location = db.collection("locations").doc(val);
    }
  },
  firestore() {
    return {
      client: db.collection("clients").doc(this.$route.params.client_id),
      videos: db.collection("video")
    };
  },
  methods: {
    validate() {
      let valid = true;

      for (let k in this.kiosk) {
        if (!this.kiosk[k]) {
          valid = false;
        }
      }

      if (valid) {
        this.save();
      } else {
        alert("Please fill in all fields");
      }
    },
    uploadImage(e) {
      this.client.client_logo = null;
      this.client.logoLoad = true;
      let image = e.target.files[0];
      console.log(image);
      let reader = new FileReader();
      reader.readAsDataURL(image);
      let vm = this;
      reader.onload = e => {
        let storageRef = storage.ref(`logos/${Date.now()}.png`);
        let uploadTask = storageRef.put(image);

        uploadTask.on(
          "state_changed",
          snapshot => {},
          error => {
            vm.logoLoad = false;
            alert("could not upload logo, please try again.");
          },
          snapshot => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              vm.client.client_logo = downloadURL;
              vm.logoLoad = false;
            });
          }
        );
      };
    },
    save() {
      let vm = this;
      if (!this.client.created) {
        this.client.created = new Date();
        this.client.clicks = 0;
      }

      return db
        .collection("clients")
        .doc(this.$route.params.client_id)
        .set(vm.client, { merge: true })
        .then(() => {
          return Swal.fire("Success", "Page Updated", "success");
        })
        .then(success => {
          router.push("/clients");
        });
    }
  },
  created() {},
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "url"],
      threshold: 0.3
    });
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions{
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.upload {
  margin-top: 2.2em;
  display: flex
}
</style>
